/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Time_Locked_SubtitleInputs */

const en_workflow_time_locked_subtitle = /** @type {(inputs: Workflow_Time_Locked_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will be recorded at the current time and can't be backdated.`)
};

const ja_workflow_time_locked_subtitle = /** @type {(inputs: Workflow_Time_Locked_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在時刻で記録され、過去の日時には変更できません。`)
};

const fr_workflow_time_locked_subtitle = /** @type {(inputs: Workflow_Time_Locked_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela sera enregistré à l’heure actuelle et ne peut pas être antidaté.`)
};

const de_workflow_time_locked_subtitle = /** @type {(inputs: Workflow_Time_Locked_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies wird mit der aktuellen Uhrzeit erfasst und kann nicht zurückdatiert werden.`)
};

/**
* | output |
* | --- |
* | "This will be recorded at the current time and can't be backdated." |
*
* @param {Workflow_Time_Locked_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const workflow_time_locked_subtitle = /** @type {((inputs?: Workflow_Time_Locked_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Time_Locked_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_time_locked_subtitle(inputs)
	if (locale === "ja") return ja_workflow_time_locked_subtitle(inputs)
	if (locale === "fr") return fr_workflow_time_locked_subtitle(inputs)
	return de_workflow_time_locked_subtitle(inputs)
});